"use strict";

import Vue from 'vue';
import axios from "axios";
import router from '../Router/router'

// Full config:  https://github.com/axios/axios#request-config
// axios.defaults.baseURL = process.env.baseURL || process.env.apiUrl || '';
// axios.defaults.headers.common['agency_id'] = 281;
// axios.defaults.headers.common['token'] = "611dbe20289da1719c7b3092";
// axios.defaults.headers.common['agency_id'] = sessionStorage.getItem("agency_id");
// axios.defaults.headers.common['token'] = sessionStorage.getItem("token");
// axios.defaults.headers.post['Content-Type'] = 'multipart/form-data';

// 自动判断当前环境
var thisUrl = window.location.origin
var url = ""
    // "http://apinew2.5kjs.com/activity.camp/getLessonSign",//测试地址
    // url: "https://apinew.5kjs.com/activity.camp/getLessonSign",//正式地址
    // url: "http://apinew.xueba.hk/activity.camp/getLessonSign",//本地地址
if (thisUrl.search(/test2.5kjs/g) != -1) {
    url = "http://apinew2.5kjs.com/activity.camp/"
} else if (thisUrl.search(/hnjszp.xueba/g) != -1) {
    url = "http://apinew.xueba.hk/activity.camp/"
} else if (thisUrl.search(/localhost:/g) != -1) {
    url = "http://apinew.xueba.hk/activity.camp/"
} else {
    url = "https://apinew.5kjs.com/activity.camp/"
}

console.log(url)

let config = {
    // 自动判断当前环境（生产环境，测试环境，开发环境）
    baseURL: url
        // 正式服
        // baseURL: "https://apinew.5kjs.com/activity.camp/"
        // 测试服
        // baseURL: "http://apinew2.5kjs.com/activity.camp/",
        // 本地服
        // baseURL: "http://apinew.xueba.hk/activity.camp/"
        // timeout: 60 * 1000, // Timeout
        // withCredentials: true, // Check cross-site Access-Control
};

const _axios = axios.create(config);



// 请求拦截器
_axios.interceptors.request.use(
    function(config) {

        // let nowUrl = window.location.href
        // nowUrl = nowUrl.replace(/#/g, 'vue')
        // console.log(nowUrl)
        // let url = window.location.origin
        // console.log(url + "/login?turn_jump_url=" + nowUrl)

        // Do something before request is sent
        return config;
    },
    function(error) {
        // Do something with request error
        return Promise.reject(error);
    }
);

// 响应拦截器
// Add a response interceptor
var flag202 = true //202状态控制阀，去除短时间多次202判断
_axios.interceptors.response.use(
    function(response) {
        // Do something with response data
        // 使用axios过滤器过滤数据， 如果请求返回状态码为200成功， 则过滤其他数据， 只返回响应的数据

        if (response.data.code == 202) {
            // 未登录则跳登录页的判定————————————————————————————————————————————————————————————————————
            // window.localStorage.removeItem('token')
            // let nowUrl = window.location.href
            // nowUrl = nowUrl.replace(/#/g, 'vue')
            // let url = window.location.origin
            // if (sessionStorage.getItem("distrid") != null) {
            //     window.location.href = url + "/login?turn_jump_url=" + nowUrl + "&distrid=" + sessionStorage.getItem("distrid")
            // } else {
            //     window.location.href = url + "/login?turn_jump_url=" + nowUrl
            // }
            // 未登录则跳登录页的判定—————————————————————————————————————————————————————————————————————

            // 未登录则跳详情页 (应该分两种情况，一种是无token登录，一种是有token但是过期登录)
            // 首先判断用户是没有登录还是已登录但是Token过期

            if (!flag202) {
                return
            }
            flag202 = false //当控制阀打开之后设置一个定时器，在800毫秒之后自动关闭
            setTimeout(() => {
                flag202
            }, 800)


            let nowUrl = window.location.href
            nowUrl = nowUrl.replace(/#/g, 'vue') //跳转登录或则退出登录页面识别路径的参数
            let url = window.location.origin //当前根域名
            if (window.localStorage.getItem("token") != null) {
                window.localStorage.removeItem('token')
                alert("您的登录已过期，请重新登录")
                    // 判断是否有分销参数

                window.sessionStorage.setItem("login", true) //添加登录过期判断状态，用于退出登录之后自动跳转登录

                if (sessionStorage.getItem("distrid") != null) {
                    window.location.href = url + "/logout?turn_jump_url=" + nowUrl + "&distrid=" + sessionStorage.getItem("distrid")
                } else {
                    window.location.href = url + "/logout?turn_jump_url=" + nowUrl
                }
            } else {
                //如果没有token则获取当前campID参数，判断是否有ID参数

                // 这里用于202无token的情况下的控制阀，去除短时间多次判断的BUG
                var campID = router.app.$route.query.camp
                    // 如果有campID则跳转至对应训练营的详情页
                if (campID != null) {
                    // 判断当前状态下的参数是否有分销参数
                    if (sessionStorage.getItem("distrid") != null) {
                        router.push({ path: `/Detail/apply/${campID}` + "&distrid=" + sessionStorage.getItem("distrid") })
                    } else {
                        router.push({ path: `/Detail/apply/${campID}` })
                    }
                } else {
                    // 如果没有campID则跳转至登录页
                    // 判断当前状态下的参数是否有分销参数
                    if (sessionStorage.getItem("distrid") != null) {
                        window.location.href = url + "/login?turn_jump_url=" + nowUrl + "&distrid=" + sessionStorage.getItem("distrid")
                    } else {
                        window.location.href = url + "/login?turn_jump_url=" + nowUrl
                    }
                }
            }
        }
        if (response.data.code == 404) {
            // 在首页的getcamp接口中返回404不要跳404页面 返回空值
            // 获取当前请求公共字段
            let mybaseURL = response.config.baseURL
                // 获取当前请求全部字段
            let allUrl = response.config.url
                // 截取字段获取当前API
            let api = allUrl.split(mybaseURL)[1]
            if (api == "getCamp") {
                response.data.data = null
                return response.data.data
            } else {
                window.localStorage.removeItem('token')
                router.push({
                    path: "/*"
                })
            }
        }
        if (response.data.code == 200) {
            if (response.data.data == null) {
                return response.data.data
            }
            response.data.data.code = 200
                // console.log(response)
                // Object.assign(response.data.data.code, { code: 200 })
            return response.data.data
        }
        return response
    },
    function(error) {
        // Do something with response error
        return Promise.reject(error);
    }
);

Plugin.install = function(Vue) {
    Vue.axios = _axios;
    window.axios = _axios;
    Object.defineProperties(Vue.prototype, {
        axios: {
            get() {
                return _axios;
            }
        },
        $axios: {
            get() {
                return _axios;
            }
        },
    });
};

Vue.use(Plugin)

export default Plugin;